import React, { useMemo } from "react";
import * as S from "./CmpSelect.style";
import { PopUpPayload } from "../genericTemplate/GenericTemplate.style";
import { useTranslation } from "react-i18next";

// pipes
import * as P from "../../../../../../../utils/pipes";

// Component
import ZaiaSelect from "../../../../../../zaiaComponents/zaiaSelect";

import Popup from "reactjs-popup";
import useGetListOptions from "../../../../../../../hooks/useGetListOptions";
import FlorenzSelect from "../../../../../../florenzComponents/florenzSelect/FlorenzSelect";

function CmpSelect({
  item,
  insertfunction,
  inline = false,
  customFormChangesList,
  customFormChangeItem,
  customFormFields,
  typeView,
  isHistorical,
}) {
  const {
    t,
    i18n: { language },
  } = useTranslation("global");

  const itemParent = useMemo(() => {
    const itemParent = customFormChangesList.find(
      (change) => change.customFormFieldId === item?.customFormFieldParentId
    );
    return itemParent;
  }, [item, customFormChangesList]);

  const {listOptions} = useGetListOptions(item, itemParent, customFormFields, isHistorical);

  const handleFunction = (optionKey) => {
    const userToCustomFormField = {
      customFormFieldId: item.id,
      parentKey: item?.customFormTypeField.fieldOptions.find(
        (field) => field.key === optionKey
      ).parentKey,
      customFormFieldParentId: item?.customFormFieldParentId,
      value: P.dataTranslation(
        item?.customFormTypeField.fieldOptions.find(
          (field) => field.key === optionKey
        ).names,
        language
      ),
      key: optionKey,
    };
    insertfunction(userToCustomFormField);
  };

  const displayValue = useMemo(() => {
      return customFormChangeItem && customFormChangeItem.key;
    }, [customFormChangeItem]);

  return (
    <S.CmpSelect inline={inline}>
      <div className="selection-container">
        <div className="title">
          <div className="title__text">
            {P.dataTranslation(item?.fieldName, language)}
          </div>
          {
            displayValue
            ? <i className="title__icon icon zaia-i-check-1"></i>
            : <div className="title__required error">{(!item.optional && listOptions.length > 0) && "*"}</div>
          }
          <Popup
            trigger={
              <i className="title__icon-payload icon zaia-alert"></i>
            }
            on={["hover", "focus"]}
            closeOnDocumentClick
            keepTooltipInside
            position={["right center"]}
            nested
          >
            <PopUpPayload>
              <p>{P.dataTranslation(item.descript, language)}</p>
            </PopUpPayload>
          </Popup>
        </div>
        <div className="input-container">
          {/* <ZaiaSelect
            type="select"
            name="phoneLocation"
            setValue={handleFunction}
            value={displayValue}
            items={listOptions.map((field) => {
              return {
                value: field.key,
                text: P.dataTranslation(field.names, language),
              };
            })}
            shadow={true}
            disabled={typeView === "view"}
            padding={"20px"}
            borderRadius={"70px"}
            textColor={"#FFFFFF"}
            backgroundColor={"#36369B"}
            borderColor={"transparent"}
            textItemsColor={"#36369B"}
            heightList={"200px"}
            fontSize="20px"
          /> */}

          <FlorenzSelect
            xsSize={false}
            forWhiteBackgroud 
            label={displayValue ? "" : t("globally.select")}
            items={listOptions.map((field) => {
              return {
                value: field.key,
                text: P.dataTranslation(field.names, language),
              };
            })}
            value={displayValue}
            setValue={handleFunction}
            heightList={"200px"}
            required={!item.optional && listOptions.length > 0}
            disabled={typeView === "view"}
          />
        </div>
      </div>
    </S.CmpSelect>
  );
}

export default CmpSelect;
